<template>
  <div class="skeleton-card">
    <div class="skeleton-avatar shimmer"></div>
    <div class="skeleton-line short shimmer"></div>
    <div class="skeleton-line shimmer"></div>
    <div class="skeleton-line shimmer"></div>
    <div class="skeleton-line shimmer"></div>
    <div class="skeleton-footer shimmer"></div>
  </div>
</template>

<style scoped>

.skeleton-card {
  height: 200px;
  max-width: 400px;
  background-color: var(--card-bg, #f1f1f1);
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 12px;
}

.skeleton-line {
  height: 12px;
  background: #ccc;
  margin-bottom: 8px;
  border-radius: 6px;
}

.skeleton-line.short {
  width: 60%;
}

.skeleton-footer {
  width: 100%;
  height: 20px;
  background: #ccc;
  border-radius: 8px;
  margin-top: auto;
}

.shimmer {
  background: linear-gradient(
    to right,
    #e0e0e0 0%,
    #f5f5f5 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>